import type { ReactElement } from 'react'
import type { ContactCardFacts } from 'app/components/lists/card/contactCardFacts'

/** The play's label, unless the tags or the appointment chip already say it. */
export function CueSection({ derived }: { derived: ContactCardFacts }): ReactElement | null {
  const { play, showPlay } = derived
  if (!showPlay) return null
  return <p className="mt-1 truncate text-body-xs text-subtle">{play.label}</p>
}
